/*globals Stripe*/
$('body').on('click', '.select-campaign-trigger', function() {
    var $this = $(this);
    var amounts = JSON.parse($this.attr('data-amounts'));

    $('.select-campaign-trigger').removeClass('active');
    $this.addClass('active');

    $('[name="campaign"]').val($this.attr('data-campaign'));
    $('.other-amount input').val('');
    $('[name="amount"]').val('0');

    $('.amounts ul').html('');
    $.each(amounts, function(index, amount) {
        $('.amounts ul').append(`<li>
            <a href="" class="select-amount-trigger" data-amount="${amount.amount}">
                $${amount.amount}
                <span>${amount.description}</span>
            </a>
        </li>`);
    });
    
    return false;
});

$('body').on('click', '.select-amount-trigger', function() {
    var $this = $(this);
    var amount = $this.attr('data-amount');

    $('.select-amount-trigger').removeClass('active');
    $this.addClass('active');

    $('.other-amount input').val('');
    $('[name="amount"]').val(amount);
    $('.select-amount-trigger[data-amount="' + amount + '"]').addClass('active');

    return false;
});

$('body').on('focus', '.other-amount input', function() {
    $('.select-amount-trigger').removeClass('active');
    $('[name="amount"]').val('0');
    return false;
});

$('body').on('blur', '.other-amount input', function() {
    var $this = $(this);
    var amount = parseFloat($this.val());
    amount = isNaN(amount) ? 0 : amount;
    $('[name="amount"]').val(amount);
    return false;
});

$('body').on('change', '[name="honor"]', function() {
    var $this = $(this);

    if($this.prop('checked')) {
        $('[name="honoree"]').focus();
        $('[name="honoree"]').addClass('required');
    } else {
        $('[name="honoree"]').removeClass('required');
    }
    
    return false;
});

$('body').on('focus', '[name="honoree"]', function() {
    var $this = $(this);

    $this.addClass('required');
    $('[name="honor"]').prop('checked', true);
    
    return false;
});


function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$('body').on('submit', '.donate form', function() {
    var $this = $(this);

    var amount = parseFloat($('.donate input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Error', 'Please choose an amount to donate', 'close');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();

    // check if we are paypal
    var payload = {};

    // setup the token
    Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    Stripe.card.createToken(
        {
            name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
            number: $('input[name="card_number"]', $this).val(),
            cvc: $('input[name="cvv"]', $this).val(),
            // exp: $('input[name="expiry"]', $this).val(),
            exp_month: $('input[name="month"]', $this).val(),
            exp_year: $('input[name="year"]', $this).val(),
            address_line1: $('input[name="street"]', $this).val(),
            address_state: $('input[name="state"]', $this).val(),
            address_zip: $('input[name="zip"]', $this).val()
        },
        function(status, response) {
            // console.log(response);
            if (response.error) {
                unloading();
                showNotice('Error', response.error.message, 'close');
                return false;
            }

            payload['_token'] = $('meta[name="csrf-token"]').attr('content');
            payload.stripe_token = response.id;

            payload.first_name = $('input[name="first_name"]', $this).val();
            payload.last_name = $('input[name="last_name"]', $this).val();
            payload.street = $('input[name="street"]', $this).val();
            payload.city = $('input[name="city"]', $this).val();
            payload.state = $('input[name="state"]', $this).val();
            payload.zip = $('input[name="zip"]', $this).val();
            payload.email = $('input[name="email"]', $this).val();
            payload.phone = $('input[name="phone"]', $this).val();
            payload.brand = response.card.brand;
            payload.last_four = response.card.last4;
            payload.month = response.card.exp_month;
            payload.year = response.card.exp_year;
            payload.amount = $('input[name="amount"]', $this).val();
            payload.source = $('input[name="source"]', $this).val();
            payload.campaign = $('input[name="campaign"]', $this).val();
            payload.message = $('[name="message"]', $this).val();
            payload.recurring = $('[name="recurring"]', $this).prop('checked'),
            payload.honoree = $('[name="honoree"]', $this).val(),
            payload.method = 'card';

            $.ajax({
                type: 'POST',
                url: $this.attr('action'),
                data: payload,
                dataType: 'json',
                success: function(data) {
                    console.log(data);
                    unloading();

                    if (!data.success) {
                        showNotice('Error', data.message, 'close');
                        return false;
                    }

                    // $this[0].reset();
                    // closeModal();
                    // $('.donation-thanks-usd [data-input="header"]').html(data.header);
                    // $('.donation-thanks-usd [data-input="message"]').html(data.message);
                    // openModal('.donation-thanks-usd', 500, true);

                    $this[0].reset();
                    closeModal();
                    showNotice('Success', data.message, 'close');
                },
                error: function(request) {
                    console.log(request.responseText);
                }
            });

            return false;
        }
    );

    return false;
});